var _g;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgReportWord = function SvgReportWord(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-873-828H495V787H-873z"
  }), /*#__PURE__*/React.createElement("g", {
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.452.5h1.36v1.809c2.43.013 4.86-.025 7.288.013a.78.78 0 0 1 .877.864c.039 4.454-.009 8.91.023 13.365-.023.456.045.963-.22 1.367-.332.236-.762.206-1.148.224-2.274-.01-4.547-.006-6.82-.006v1.808h-1.42c-3.459-.628-6.926-1.205-10.39-1.808-.003-5.275 0-10.55 0-15.823C3.483 1.707 6.968 1.117 10.451.5Z",
    fill: "#2A5699"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.667 3.278h7.777v14.444h-7.777v-1.805h6.128v-.903h-6.128v-1.129h6.128v-.902h-6.128v-1.129h6.128v-.903h-6.128V9.823h6.128V8.92h-6.128V7.792h6.128v-.903h-6.128V5.76h6.128v-.902h-6.128v-1.58ZM4.495 7.43c.43-.025.86-.043 1.29-.065.301 1.527.609 3.051.935 4.571.256-1.57.539-3.135.813-4.702.452-.016.905-.041 1.356-.068-.512 2.192-.96 4.402-1.52 6.58-.377.197-.943-.01-1.392.023-.3-1.498-.652-2.986-.921-4.49-.265 1.46-.61 2.909-.913 4.361a85.39 85.39 0 0 1-1.308-.08c-.376-1.99-.818-3.967-1.168-5.962.387-.018.776-.034 1.163-.048.233 1.441.498 2.875.702 4.318.32-1.479.646-2.958.963-4.438Z",
    fill: "#FFF"
  })))));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgReportWord, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/report-word.28727532.svg";
export { ForwardRef as ReactComponent };